import Vue from 'vue'
import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { loadPage } from './mixins'
import { weixinFunc } from './mixins/wx.js'
import { createProvider } from './apollo'
import Vant from 'vant'
import 'vant/lib/index.css'
import VueClipboard from 'vue-clipboard2'
import moment from 'moment'
import constants from './utils/constants'
import cloneDeep from 'lodash.clonedeep'
// import zhuge from './zhuge'
// zhuge()

Raven.config(constants.SENTRY_URL, {
  release: process.env.RELEASE_VERSION // 设置版本号
}).addPlugin(RavenVue, Vue)
  .install()

Vue.use(Vant)
Vue.use(VueClipboard)
Vue.config.productionTip = false
Vue.mixin(loadPage)
Vue.mixin(weixinFunc)
// moment.tz.setDefault('Asia/Shanghai') // 设置默认时区
Vue.prototype.$moment = moment
Vue.prototype.$consts = constants
Vue.prototype.$clone = cloneDeep
Vue.prototype.$sentry = Raven
// Vue.prototype.$zhuge = window.zhuge

new Vue({
  router,
  store,
  apolloProvider: createProvider,
  render: h => h(App)
}).$mount('#app')
